export function isValidCurrency(amount: string) {
  // Allow integers and numbers with up to 2 decimal places, with an optional leading $
  return /^\$?(?:\d*[0-9](?:\.[0-9]{1,2})?|\.[0-9]{1,2})$/.test(amount);
}

export function isValidPhoneNumber(phoneNumber = '') {
  const phoneNumberWithoutWhitespace = phoneNumber.replace(/\s/g, '');
  // Check if phone number contains a valid area code, and has the correct number of digits
  return /^0[23478]\d{8}$/.test(phoneNumberWithoutWhitespace);
}
